import { render, staticRenderFns } from "./ListChatAdmin.vue?vue&type=template&id=33105982&scoped=true&"
import script from "./ListChatAdmin.vue?vue&type=script&lang=js&"
export * from "./ListChatAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ListChatAdmin.vue?vue&type=style&index=0&id=33105982&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33105982",
  null
  
)

export default component.exports